import { gsap } from "gsap";

export default class Accordions {
    constructor() {
        this.init();
    }

    init() {
        const items = gsap.utils.toArray(".accordion-item");
        if (!items.length) return;

        this.items = items.map((root, i) => this.setupItem(root, i));

        this.items.forEach((it, i) => {
            const hasAttr = it.root.hasAttribute("data-default-open");
            const open = hasAttr ? it.root.dataset.defaultOpen === "true" : i === 0;

            this.setInitialState(it, open);
        });
    }

    setupItem(root, index) {
        const header = root.querySelector(".accordion-item_header");
        const btn = header?.querySelector(".question_btn") || header;
        const panel = root.querySelector(".accordion-item_content");

        const panelId = panel.id || `acc-panel-${index + 1}`;
        if (panel && !panel.id) panel.id = panelId;

        btn.setAttribute("aria-controls", panelId);

        panel.style.overflow = "hidden";

        const handleClick = (e) => {
            if (e.target.closest("a, button") && e.target !== btn) return;

            e.preventDefault();
            const willOpen = btn.getAttribute("aria-expanded") !== "true";
            this.toggle(root, willOpen);
        };

        btn.addEventListener("click", handleClick);

        return { root, header, btn, panel };
    }

    setInitialState(it, open) {
        it.btn.setAttribute("aria-expanded", open ? "true" : "false");
        it.root.classList.toggle("active", open);

        if (open) {
            it.panel.hidden = false;
            gsap.set(it.panel, { height: "auto", autoAlpha: 1 });
        } else {
            it.panel.hidden = true;
            gsap.set(it.panel, { height: 0, autoAlpha: 0 });
        }
    }

    toggle(root, open) {
        this.items.forEach((it) => {
            if (it.root !== root && it.btn.getAttribute("aria-expanded") === "true") {
                this.animateClose(it);
            }
        });

        const current = this.items.find((it) => it.root === root);
        if (!current) return;

        open ? this.animateOpen(current) : this.animateClose(current);
    }

    animateOpen(it) {
        const el = it.panel;
        gsap.killTweensOf(el);

        el.hidden = false;
        el.style.height = "auto";

        const height = el.scrollHeight;

        it.root.classList.add("active");
        it.btn.setAttribute("aria-expanded", "true");

        gsap.fromTo(el,
            { height: 0, autoAlpha: 0 },
            {
                height: height,
                autoAlpha: 1,
                duration: 0.45,
                ease: "power2.out",
                onComplete: () => {
                    el.style.height = "auto";
                }
            }
        );
    }

    animateClose(it) {
        const el = it.panel;
        gsap.killTweensOf(el);

        el.style.height = el.offsetHeight + "px";

        it.root.classList.remove("active");
        it.btn.setAttribute("aria-expanded", "false");

        gsap.to(el, {
            height: 0,
            autoAlpha: 0,
            duration: 0.35,
            ease: "power2.inOut",
            onComplete: () => {
                el.hidden = true;
            },
        });
    }
}